/**
 * app分享注册页面
 */
<template>
  <div class="register-wrapper">
      <div class="register-body">
        <form action=""  class="custom-form">
          <div class="form-item">
            <div class="form-label">手机号</div>
            <div class="form-control">
              <input name="phone" type="text" maxlength="11" class="form-input" placeholder="请输入手机号" v-model="phone">
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">验证码</div>
            <div class="form-control ">
              <input class="form-input" name="authcode" maxlength="10" type="text" placeholder="请输入验证码" v-model="authcode">
            </div>
            <button class="form-code-btn" :disabled="disabled" @click="sendCode">{{btntxt}}</button>
          </div>
          <div class="form-item form-item-button">
            <button class="form-button" type="submit" @click="formCodeSubmit" :disabled="loading">注册</button>
          </div>
          <div class="form-item">
            <div></div>
            <div class="form-item-rule">
              <i class="iconfont" :class="[ iconClassName ? 'icon-kselect' : 'icon-kunselect']" @click="handleRead"></i>
              我已阅读并同意<span class="protocol" @click="viewProtocol">《便捷青岛用户协议》</span>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { apiSendCode, apiRegister } from '@/api/index'

export default {
  name: 'shareregister',
  data () {
    return {
      loading: false,
      show: true,
      disabled: false,
      time: 0,
      btntxt: '获取验证码',
      phone: '',
      authcode: '',
      iconClassName: false,
      invitationCode: ''
    }
  },
  created () {
    this.invitationCode = this.$route.query.p
  },
  methods: {
    handleRead () {
      this.iconClassName = !this.iconClassName
    },
    viewProtocol () {
      this.$router.push('/protocol')
    },
    formCodeSubmit (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.authcode) {
        Toast({
          message: '验证码不能为空'
        })
        return
      }
      if (!this.iconClassName) {
        Toast({
          message: '请勾选已阅读便捷青岛用户协议'
        })
        return
      }
      let data = {
        phone: this.phone,
        authCode: this.authcode,
        registerType: 6,
        clientId: 'bjqd',
        invitationCode: this.invitationCode
      }
      if (this.phone === this.invitationCode) {
        Toast({
          message: '自己不能邀请自己'
        })
        return
      }
      this.loading = true
      apiRegister(data).then((res) => {
        if (res.data.code === 50110) {
          this.$router.push({ path: 'shareAppDownload', query: { num: '', type: 1 } })
        } else if (res.data.code === 200) {
          this.$router.push({ path: 'shareAppDownload', query: { num: res.data.result, type: 2 } })
        } else {
          Toast({
            message: res.data.message
          })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    checkPhone (phone) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    },
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '获取验证码'
        this.disabled = false
      }
    },
    sendCode (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      } else if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
      let data = {
        clientId: 'bjqd',
        phone: this.phone
      }
      apiSendCode(data).then((res) => {
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
          if (res.data.code === 50003) {
            // 已注册
            setTimeout(() => {
              this.$router.push({ path: 'shareAppDownload', query: { num: '' } })
            }, 1500)
          }
        }
      })
    }

  }
}

</script>
<style lang='scss' scoped>
.register-wrapper {
  box-sizing: border-box;
  min-height: 100vh;
  background: #f1f1f1;
  overflow-x: hidden;
  background: url('https://oss.aqdpay.com/appweb/shareApp/registerbg.png') no-repeat;
  background-size: 100%;
}
.register-header {
  text-align: center;
  img {
    width: 100%;
  }
}
.register-body {
  position: relative;
  top: 45vh;
  padding: 8px 15px 15px 15px;
}
.custom-form {
  padding: 20px 0 35px;
  border-radius: 8px;
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  padding:  12px 18px;
  overflow: hidden;
  &:last-child {
    border-bottom: 1px solid  transparent;
  }
}
.form-item.form-item-button {
  padding: 20px 0  10px;
}
.form-label {
  font-size: 16px;
  color: #333;
  margin-right: 10px;
  white-space: nowrap;
}
.form-input {
  width: 80%;
  font-size: 14px;
}
.form-button {
  box-sizing: border-box;
  width: 90%;
  margin: 0 auto;
  padding: 10px 5px;
  background: #4a83f3;
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
}

.form-code {
  display: flex;
  align-items: center;
}
.form-code-btn {
  padding: 5px;
  white-space: nowrap;
  font-size: 15px;
  color: #228aff;
  background: #fff;
  line-height: 1;
  outline: none;
}
.form-item-rule {
  width: 100%;
  font-size: 14px;
  padding-left: 8px;
  .iconfont {
    margin-right: 3px;
  }
  .icon-select {
    color: #3e98ff;
  }
  .protocol {
    color: #228aff;
  }
}

</style>
